/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import Campaign, { CampaignState, CAMPAIGN_STATE_CLASSES, CAMPAIGN_STATE_LABELS } from 'cio/models/campaign';

type TooltipDirection = 'top' | 'right' | 'bottom' | 'left';

const CAMPAIGN_STATE_DISPLAY_DATA: Record<CampaignState, { label: string; class: string; tooltipContent: string }> = {
  archiving: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Archiving],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Archiving],
    tooltipContent: 'This Campaign is in the process of being archived',
  },
  archived: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Archived],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Archived],
    tooltipContent: "Campaign is archived and doesn't send any messages",
  },
  unarchiving: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Unarchiving],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Unarchiving],
    tooltipContent: 'This Campaign is in the process of being unarchived',
  },
  draft: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Draft],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Draft],
    tooltipContent: 'Not yet matching customers or sending messages',
  },
  running: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Running],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Running],
    tooltipContent: 'Campaign triggers and message workflow are live',
  },
  sunsetting: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Sunsetting], // this has the same label as "stopping" state, with different tooltip text
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Sunsetting],
    tooltipContent: 'This Campaign will stop after all in progress people have finished their journey',
  },
  stopping: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Stopping],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Stopping],
    tooltipContent: 'This Campaign is in the process of being stopped.',
  },
  stopped: {
    label: CAMPAIGN_STATE_LABELS[CampaignState.Stopped],
    class: CAMPAIGN_STATE_CLASSES[CampaignState.Stopped],
    tooltipContent: "Campaign is stopped and doesn't send any messages",
  },
};

interface CampaignStateLabelArgs {
  campaign: Campaign;
  tooltipDirection?: TooltipDirection;
}

export default class CampaignStateLabel extends Component<CampaignStateLabelArgs> {
  get displayData() {
    return CAMPAIGN_STATE_DISPLAY_DATA[this.args.campaign.state as CampaignState];
  }

  get tooltipDirection(): TooltipDirection {
    return this.args.tooltipDirection ?? 'bottom';
  }
}
